import ongCardDetailsComponent from './ongCardDetails.component';

let ongCardDetailsModule = angular.module('solidarity.ongCardDetails', [])

.component('ongCardDetails', ongCardDetailsComponent)

.name;

export default ongCardDetailsModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/ongsList/ongCard/ongCardDetails/ongCardDetails.js